import { useContext } from 'react';

import { SpdCoreContext } from '../spdCore';

export const useSpdCore = () => useContext(SpdCoreContext);
